<ion-header mode="ios" class="ion-no-border" [translucent]="true">
	<ion-toolbar>
		<ion-title size="lg">{{ 'preferences|title' | transloco }}</ion-title>
		<ion-buttons slot="start" class="p-1">
			<button
				(click)="onCancel()"
				type="button"
				ultra-button
				svgIcon="arrow_back"></button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content
	[fullscreen]="true"
	[class]="isDesktop() ? 'ion-content-padding' : 'ion-content-mobile-padding'">
	<div class="flex flex-col gap-2">
		<div class="flex flex-col mb-4">
			<form
				id="admin-preferences-form"
				[formGroup]="preferencesForm"
				(ngSubmit)="onSubmit()">
				<h2 class="text-lg font-medium mb-2">
					{{ 'preferences|section|general' | transloco }}
				</h2>
				<app-toggle-new
					formControlName="isTaxIncluded"
					label="preferences|is-tax-included|label"
					class="mb-2" />
				<app-input-field
					[isNumber]="true"
					formControlName="availabilityThreshold"
					label="preferences|availability-threshold|label"
					class="mb-2" />

				<app-single-dropdown
					hideClearButton
					formControlName="language"
					[label]="'preferences|language-selector|label'"
					[selectOptions]="langs" />

				<h2 class="text-lg font-medium mt-6 mb-2">
					{{ 'preferences|section|integrations' | transloco }}
				</h2>

				<div formGroupName="integrations">
					<h3 class="text-md font-medium mb-2">
						{{ 'preferences|integrations|gps-tracksolid|title' | transloco }}
					</h3>
					<div formGroupName="gpsTrackers">
						<app-toggle-new
							formControlName="isEnabled"
							[label]="
								'preferences|integrations|gps-tracksolid|enabled' | transloco
							"
							class="mb-2" />
						<div formGroupName="trackSolid">
							<app-input-field
								formControlName="baseUrl"
								[label]="
									'preferences|integrations|gps-tracksolid|base-url' | transloco
								"
								class="mb-2" />
							<app-input-field
								formControlName="account"
								[label]="
									'preferences|integrations|gps-tracksolid|account' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.gpsTrackers.trackSolid.account',
										integrationSecretHints().trackSolid.isAccountConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="appKey"
								[label]="
									'preferences|integrations|gps-tracksolid|app-key' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.gpsTrackers.trackSolid.appKey',
										integrationSecretHints().trackSolid.isAppKeyConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="appSecret"
								[label]="
									'preferences|integrations|gps-tracksolid|app-secret'
										| transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.gpsTrackers.trackSolid.appSecret',
										integrationSecretHints().trackSolid.isAppSecretConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="password"
								[label]="
									'preferences|integrations|gps-tracksolid|password' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.gpsTrackers.trackSolid.password',
										integrationSecretHints().trackSolid.isPasswordConfigured
									)
								"
								class="mb-2" />
						</div>
					</div>

					<h3 class="text-md font-medium mt-4 mb-2">
						{{ 'preferences|integrations|payment-providers|title' | transloco }}
					</h3>
					<div formGroupName="paymentProviders">
						<app-toggle-new
							formControlName="isEnabled"
							[label]="
								'preferences|integrations|payment-providers|enabled' | transloco
							"
							class="mb-2" />
						<app-input-field
							formControlName="apiPaymentBaseUrl"
							[label]="
								'preferences|integrations|payment|app-base-url' | transloco
							"
							class="mb-2" />
						<app-single-dropdown
							[formControl]="preferencesForm.controls.reservationMode"
							[label]="'preferences|integrations|payment-providers|reservation-mode|label'"
							[selectOptions]="reservationModeOptions"
							class="mb-4" />

						<h4 class="text-sm font-medium mb-2">
							{{ 'preferences|integrations|saferpay|title' | transloco }}
						</h4>
						<div formGroupName="saferpay">
							<app-input-field
								formControlName="apiUsername"
								[label]="
									'preferences|integrations|saferpay|api-username' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.paymentProviders.saferpay.apiUsername',
										integrationSecretHints().saferpay.isApiUsernameConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="apiPassword"
								[label]="
									'preferences|integrations|saferpay|api-password' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.paymentProviders.saferpay.apiPassword',
										integrationSecretHints().saferpay.isApiPasswordConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="customerId"
								[label]="
									'preferences|integrations|saferpay|customer-id' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.paymentProviders.saferpay.customerId',
										integrationSecretHints().saferpay.isCustomerIdConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="terminalId"
								[label]="
									'preferences|integrations|saferpay|terminal-id' | transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.paymentProviders.saferpay.terminalId',
										integrationSecretHints().saferpay.isTerminalIdConfigured
									)
								"
								class="mb-2" />
							<app-input-field
								formControlName="securePayGateTerminalId"
								[label]="
									'preferences|integrations|saferpay|spg-terminal-id'
										| transloco
								"
								[isPassword]="true"
								[maskUnknownStoredSecret]="
									maskIntegrationSecret(
										'integrations.paymentProviders.saferpay.securePayGateTerminalId',
										integrationSecretHints().saferpay
											.isSecurePayGateTerminalIdConfigured
									)
								"
								class="mb-2" />
						</div>
					</div>

					<h3 class="text-md font-medium mt-4 mb-2">
						{{ 'preferences|integrations|e-signatures|title' | transloco }}
					</h3>
					<div formGroupName="eSignatures">
						<app-toggle-new
							formControlName="isEnabled"
							[label]="
								'preferences|integrations|e-signatures|enabled' | transloco
							"
							class="mb-2" />
						<app-input-field
							formControlName="senderSignerName"
							[label]="
								'preferences|integrations|e-signatures|signer-name' | transloco
							"
							class="mb-2" />
						<app-input-field
							formControlName="senderSignerEmail"
							[label]="
								'preferences|integrations|e-signatures|signer-email' | transloco
							"
							class="mb-2" />
					</div>
				</div>
			</form>
		</div>
	</div>

	<ion-fab
		slot="fixed"
		vertical="bottom"
		horizontal="end"
		class="right-aligned">
		<button
			form="admin-preferences-form"
			ultra-primary
			color="primary"
			type="submit"
			[disabled]="isSubmitting()"
			content="shared|common|save"
			svgIcon="check"></button>
	</ion-fab>
	<div class="h-20 w-full" aria-hidden="true"></div>
</ion-content>
